export default __webpack_public_path__ + "11e662b80f70e349358a30c6f7bede64.png";